$(function() {
	$("#conta-login").click(function() {
		var btn = $(this);
		var email = $("#conta-email").val(); 
		var password = $("#conta-password").val();

		btn.button('loading');
		$.post('/conta/login', { email: email, password: password }, function(r) {
			btn.button('reset'); 
			if (r.response) {
				if (r.reset) {
					//exibe formulario de reset
					$('.form-changepass').show();
					$('.form-login').hide();
					$("#changepass-current").focus();
				} else {
					window.location = "/conta"
				}
			} else {
				$("#conta-password").val('');
				$("#conta-password").focus();
				$("#form-error-msg").html(r.error);
				$("#form-error-holder").fadeIn('fast');
				window.setTimeout(function() {
					$("#form-error-holder").fadeOut('fast');
				}, 5000);
			}
		}, 'json');
	});

	$("#conta-password").keyup(function(e) {
		if (e.keyCode == 13) {
			$("#conta-login").click();
		}
	})

	$("#conta-logout").click(function() {
		$.post('/conta/logout', {}, function() {
			window.location = "/conta"
		})
	});

	$("#changepass-save").click(function() {
		var btn = $(this);
		var current = $("#changepass-current").val();
		var data = {};
		var password = $("#changepass-new").val();
		var passwordcfm = $("#changepass-new").val();

		data.current = current;
		data.password = password;
		data.passwordcfm = passwordcfm;

		btn.button('loading');
		$.post('/conta/changepass', data, function(r) {
			btn.button('reset'); 
			if (r.response) {
				$('.form-changepass').hide();
				$('.form-login').show();
				$("#conta-password").val("").focus();
			} else {
				$("#form-error-msg").html(r.error);
				$("#form-error-holder").fadeIn('fast');
				window.setTimeout(function() {
					$("#form-error-holder").fadeOut('fast');
				}, 5000);
			}
		}, 'json');
	});

	$(".contas-details").click(function() {
		var ref = $(this).attr('ref');
		$("#contas-details").html("<i class='fa fa-spin fa-spinner'></i> aguarde...");
		if (ref == 'resumo') {
			$.post('/conta/details', { }, function(r) {
				$("#contas-details").html(r);
			});
		} else if (ref == 'cc') {
			$.post('/conta/cc', { classe: $(this).attr('classe') }, function(r) {
				$("#contas-details").html(r);
			});
		} else {
			$.post('/conta/cartao', { CarCod: ref }, function(r) {
				$("#contas-details").html(r);
			});
		}
	});

	$(".contas-details").first().click();
	$("#contas-periodo-df").mask('99/99/9999');
	$("#contas-periodo-di").mask('99/99/9999');

	$(document).off('click', '#contas-extrato-cartao-changeperiodo');
	$(document).on('click', '#contas-extrato-cartao-changeperiodo', function() {
		$("#contas-periodo-modal").modal('show');
		$("#contas-periodo-cfm").attr('ref', $(this).attr('ref'));
		$("#contas-periodo-df").val($(this).attr('df'))
		$("#contas-periodo-di").val($(this).attr('di'))
		$("#contas-periodo-di").focus();
	});

	$(document).off('click', '#contas-cc-changeperiodo');
	$(document).on('click', '#contas-cc-changeperiodo', function() {
		$("#contas-periodo-modal").modal('show');
		$("#contas-periodo-cfm").attr('ref', '0');
		$("#contas-periodo-cfm").attr('classe', $(this).attr('classe'));
		$("#contas-periodo-df").val($(this).attr('df'))
		$("#contas-periodo-di").val($(this).attr('di'))
		$("#contas-periodo-di").focus();
	});

	$("#contas-periodo-cfm").click(function() {
		var classe = parseInt($(this).attr('classe'));
		var df = $("#contas-periodo-df").val();
		var di = $("#contas-periodo-di").val();
		var ref = parseInt($(this).attr('ref'));

		$("#contas-periodo-modal").modal('hide');

		if (ref) {
			$.post('/conta/cartao', { CarCod: ref, di: di, df: df }, function(r) {
				$("#contas-details").html(r);
			});
		} else {
			$.post('/conta/cc', { classe: classe, di: di, df: df }, function(r) {
				$("#contas-details").html(r);
			});
		}
	});
});